import { useEffect } from 'react'
import { LuBrainCircuit, LuMessageSquare, LuInbox } from 'react-icons/lu'
import { Link } from 'react-router-dom'
import useNetwork from '../models/useNetwork'
import useToken from '../models/useToken'
import useNode from '../models/useNode'
import useSharedServices from '../models/useSharedServices'
import Stack from '@mui/material/Stack'
import Filter from './Filter'
import MapView from './MapView'
import Search from './Search'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import IconNode from './IconNode'
import TerminalsTray from './TerminalsTray'
import SideMenuStack from './SideMenuStack'
import { useOrgRole } from '../hooks/useOrgRole'
import { isOfflineFilterDisabled } from '../utilities/offlineFilter'

export default function SideMenu() {
  const { tokens } = useToken()
  const { networks } = useNetwork()
  const { nodes } = useNode()
  const nodesComplete = useNode(state => state.nodesComplete)
  const { services: sharedServices, fetch: fetchShared } = useSharedServices()
  const { can } = useOrgRole()

  useEffect(() => {
    fetchShared()
  }, [fetchShared])

  return (
    <>
      <SideMenuStack align="top">
        {!networks.length ? (
          // ⚠ Any member creates a network and owns it (docs/PERMISSIONS.md § 5 Network, app#376).
          <Button to="/network" component={Link} disabled={!can('network.create')}>
            <Typography variant="caption" color="textSecondary">
              Network
            </Typography>
            <IconNode type="network" plus />
          </Button>
        ) : (
          <Button to="/node" component={Link} disabled={!tokens.length}>
            <Typography variant="caption" color="textSecondary">
              Add
            </Typography>
            <IconNode type="node" size={42} plus offline={!tokens.length} />
          </Button>
        )}
        <Search disabled={!nodes.length} />
        <Button to="/llm" component={Link}>
          <Typography variant="caption" color="textSecondary">
            LLMs
          </Typography>
          <Stack
            sx={{
              width: 38,
              height: 38,
              alignItems: 'center',
              justifyContent: 'center',
              color: 'contrast.medium'
            }}>
            <LuBrainCircuit fontSize={20} color={undefined} />
          </Stack>
        </Button>
        <Filter disabled={isOfflineFilterDisabled({ nodeCount: nodes.length, nodesComplete })} />
        <MapView disabled={!nodes.length} />
        {sharedServices.length > 0 && (
          <Button to="/shared" component={Link}>
            <Typography variant="caption" color="textSecondary">
              Shared
            </Typography>
            <Stack
              sx={{
                width: 38,
                height: 38,
                alignItems: 'center',
                justifyContent: 'center',
                color: 'contrast.medium'
              }}>
              <LuInbox fontSize={20} />
            </Stack>
          </Button>
        )}
        <Button to="/feedback" component={Link}>
          <Typography variant="caption" color="textSecondary">
            Feedback
          </Typography>
          <Stack
            sx={{
              width: 38,
              height: 38,
              alignItems: 'center',
              justifyContent: 'center',
              color: 'contrast.medium'
            }}>
            <LuMessageSquare fontSize={20} />
          </Stack>
        </Button>
      </SideMenuStack>
      <TerminalsTray />
    </>
  )
}
